export const siArchiveConstants = {
    RESET: 'RESET',
    SI_ARCHIVE_FETCHING: 'SI_ARCHIVE_FETCHING',
    SI_ARCHIVE_FETCHED: 'SI_ARCHIVE_FETCHED',
    GET_POSTED_WB_PER_YEAR: 'GET_POSTED_WB_PER_YEAR',
    GET_POSTED_WB_PER_MONTH: 'GET_POSTED_WB_PER_MONTH',
    GET_POSTED_WB_PER_VESSEL: 'GET_POSTED_WB_PER_VESSEL',
    GET_POSTED_WB_PER_VOYAGE: 'GET_POSTED_WB_PER_VOYAGE',
    GET_POSTED_WAYBILL: 'GET_POSTED_WAYBILL',
}